import React, { Component } from "react";
import image from "../../logo.png";
import "./Register.css";
import { toEnglishNumber } from "../../classes/utils";
import withRouter from "../withRouter/withRouter";

class Register extends Component {
    constructor(props) {
        super(props);
        this.refrencePage = props.router.params["*"];
        this.mobileRef = React.createRef();
        this.passwordRef = React.createRef();
        this.checkInputs = this.checkInputs.bind(this);
    }

    state = { mode: "login" };

    checkInputs() {
        let mobile = this.mobileRef.current.value;
        let password = this.passwordRef.current.value;
        let error = false;

        if (!mobile || mobile.length != 11 || mobile.slice(0, 2) != "09") {
            //mobile number wrong format
            this.incorectElement(this.mobileRef);
            error = true;
        } else {
            this.correctElement(this.mobileRef);
        }

        if (password.length < 6) {
            //mobile number wrong format
            this.incorectElement(this.passwordRef);
            error = true;
        } else {
            this.correctElement(this.passwordRef);
        }

        return !error;
    }

    incorectElement(ref) {
        let className = ref.current.className;
        className =
            className.search("error") > -1 ? className : className + " error";
        ref.current.className = className;
    }

    correctElement(ref) {
        ref.current.className = ref.current.className.replace("error", "");
    }

    logIn() {
        let mobile = this.mobileRef.current.value;
        let password = this.passwordRef.current.value;
        if (this.checkInputs()) {
            this.props.connection
                .login(toEnglishNumber(mobile), toEnglishNumber(password))
                .then((res) => {
                    this.correctElement(this.mobileRef);
                    this.correctElement(this.passwordRef);

                    let { token, mobile } = res.data;
                    localStorage.setItem("token", token);
                    localStorage.setItem("mobile", mobile);
                    this.props.router.navigate(
                        "/" + (this.refrencePage ? this.refrencePage : "")
                    );
                })
                .catch((err) => {
                    window.alert("نام کاربری یا رمز عبور اشتباه است  ");
                });
        }
    }

    signUp() {
        let mobile = this.mobileRef.current.value;
        let password = this.passwordRef.current.value;
        if (this.checkInputs()) {
            this.props.connection
                .signup(toEnglishNumber(mobile), toEnglishNumber(password))
                .then((res) => {
                    this.correctElement(this.mobileRef);
                    this.correctElement(this.passwordRef);

                    let { token, mobile } = res.data;
                    localStorage.setItem("token", token);
                    localStorage.setItem("mobile", mobile);
                    this.props.router.navigate(
                        "/" + (this.refrencePage ? this.refrencePage : "")
                    );
                })
                .catch((err) => {
                    this.incorectElement(this.mobileRef);
                    this.incorectElement(this.passwordRef);
                    window.alert("خطا در انجام عملیات : " + err);
                });
        }
    }

    render() {
        let { mode } = this.state;
        return (
            <section className='h-100 gradient-form RegisterComponent'>
                <div className='container py-5 h-100'>
                    <div className='row d-flex justify-content-center align-items-center h-100'>
                        <div className='col-xl-10'>
                            <div className='card rounded-3 text-black'>
                                <div className='row g-0'>
                                    <div className='col-lg-6 d-flex align-items-center gradient-custom-2'>
                                        <div className='text-white px-3 py-4 p-md-5 mx-md-4'>
                                            <h4 className='mb-4'>
                                                کمترین قیمت
                                            </h4>
                                            <h4 className='mb-4'>
                                                بیشترین کیفیت
                                            </h4>
                                            <h4 className='medium mb-0 '>
                                                همین حالا وارد پنل کاربری خود
                                                شوید تا تخفیف های ویژه ی اعضای
                                                سایت بهره مند شوید
                                            </h4>

                                            <h4 className='small mb-10'>
                                                {":)"}
                                            </h4>

                                            <h4 className='medium mb-5 '>
                                                ثبت نام در کمتر از 10 ثانیه
                                            </h4>
                                        </div>
                                    </div>
                                    <div className='col-lg-6'>
                                        <div className='card-body p-md-5 mx-md-4'>
                                            <div className='text-center'>
                                                <img
                                                    className='logo'
                                                    src={image}
                                                    alt='logo'
                                                />
                                                <h3 className='mt-1 mb-5 pb-1'>
                                                    خرازی اینترنتی نیکا
                                                </h3>
                                            </div>
                                            <div className='mode'>
                                                <div
                                                    className={`signup ${
                                                        mode === "signup" &&
                                                        "selected"
                                                    }`}
                                                    onClick={(ev) =>
                                                        this.setState({
                                                            mode: "signup",
                                                        })
                                                    }
                                                >
                                                    ثبت نام
                                                </div>
                                                <div
                                                    className={`login ${
                                                        mode === "login" &&
                                                        "selected"
                                                    }`}
                                                    onClick={(ev) =>
                                                        this.setState({
                                                            mode: "login",
                                                        })
                                                    }
                                                >
                                                    ورود
                                                </div>
                                            </div>

                                            <form>
                                                <div className='form-outline mb-4'>
                                                    <label
                                                        className='form-label'
                                                        htmlFor='mobile'
                                                    >
                                                        شماره تلفن همراه
                                                    </label>
                                                    <input
                                                        type='tel'
                                                        id='mobile'
                                                        className='form-control'
                                                        placeholder='شماره موبایل'
                                                        minLength={11}
                                                        maxLength={11}
                                                        pattern='[0]{1}[9]{1}[0-9]{9}'
                                                        ref={this.mobileRef}
                                                    />
                                                </div>

                                                <div className='form-outline mb-4'>
                                                    <label
                                                        className='form-label'
                                                        htmlFor='password'
                                                    >
                                                        رمز عبور
                                                    </label>
                                                    <input
                                                        type='password'
                                                        id='password'
                                                        className='form-control'
                                                        placeholder='رمز عبور ( حداقل 6 کاراکتر )'
                                                        ref={this.passwordRef}
                                                    />
                                                </div>

                                                <div className='text-center pt-1 mb-5 pb-1'>
                                                    <button
                                                        type='button'
                                                        className='btn confirm signup'
                                                        onClick={(e) =>
                                                            mode === "login"
                                                                ? this.logIn()
                                                                : this.signUp()
                                                        }
                                                    >
                                                        {mode === "login"
                                                            ? "ورود"
                                                            : " ثبت نام"}
                                                    </button>
                                                    <br />
                                                    {
                                                        // <a href='/verify-number/forgot/forgot'>
                                                        //     <button
                                                        //         type='button'
                                                        //         className='btn warning'
                                                        //     >
                                                        //         فراموشی کلمه عبور
                                                        //     </button>
                                                        // </a>
                                                    }
                                                    <a href='/'>
                                                        <button
                                                            type='button'
                                                            className='btn danger'
                                                        >
                                                            انصراف
                                                        </button>
                                                    </a>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

export default withRouter(Register);
